/**
 * Login / logout / sesión (tokens en localStorage; usuario persistido en Zustand `authStore`).
 * Rutas en `api/endpoints.js`; transporte en `api/httpClient.js`.
 */

import { authApi } from "./endpoints";
import {
  clearStoredTokens,
  getStoredRefreshToken,
  setStoredTokens,
} from "services/tokenStorage";

export async function apiLogin(email, password) {
  const { res, data } = await authApi.login({ email, password });
  if (!res.ok) {
    const msg =
      data?.error ||
      data?.message ||
      (res.status === 401 ? "Credenciales inválidas." : "Error al iniciar sesión.");
    throw new Error(msg);
  }
  if (data?.tokens?.accessToken) {
    setStoredTokens(data.tokens.accessToken, data.tokens.refreshToken || "");
  }
  return data;
}

export async function apiVerifyLoginCode(challengeId, code) {
  const { res, data } = await authApi.verifyLoginCode({
    challengeId,
    code: String(code || "").trim(),
  });
  if (!res.ok) {
    const msg =
      data?.error ||
      data?.message ||
      (res.status === 401 ? "Código inválido o expirado." : "No se pudo verificar el código.");
    throw new Error(msg);
  }
  if (data?.tokens?.accessToken) {
    setStoredTokens(data.tokens.accessToken, data.tokens.refreshToken || "");
  }
  return data;
}

export async function apiResendLoginCode(challengeId) {
  const { res, data } = await authApi.resendLoginCode({ challengeId });
  if (!res.ok) {
    const msg =
      data?.error || data?.message || "No se pudo reenviar el código.";
    throw new Error(msg);
  }
  return data;
}

export async function apiLogout() {
  const refresh = getStoredRefreshToken();
  try {
    await authApi.logout(refresh ? { refreshToken: refresh } : {});
  } catch {
    /* ignorar red */
  }
  clearStoredTokens();
}

export async function apiGetMe() {
  const { res, data } = await authApi.me();
  if (res.ok && data?.ok) {
    return data;
  }
  // Solo se cierra la sesión cuando el servidor dice que la credencial no sirve.
  // Antes se borraban los tokens ante CUALQUIER respuesta no-ok: un 500, un
  // timeout o una caída momentánea de la API echaban al usuario aunque su
  // sesión estuviera perfecta. Para el 401 real, el transporte ya intentó
  // renovar con el refresh token antes de llegar acá.
  if (res.status === 401 || res.status === 403) {
    clearStoredTokens();
  }
  return null;
}

export {
  apiRequest,
  apiGet,
  apiGetText,
  apiPost,
  apiPatch,
  apiPut,
  apiDelete,
  apiPostForm,
  apiPatchForm,
  joinUrl,
} from "./httpClient";

export {
  paths,
  api,
  authApi,
  organizationsApi,
  organizationApiKeysApi,
  organizationCronJobsApi,
  cafStockApi,
  foliosApi,
  dteDocumentsApi,
  dteBooksApi,
  emissionProfilesApi,
  gmailDteInboxApi,
  emissionsApi,
  librosApi,
} from "./endpoints";
